import { Container } from "./Container";
import { Steps } from "./Steps";
import { Step } from "./Step";
import { Header } from "./Header";
import { Video } from "./Video";
import { TextBlock } from "./TextBlock";
import { MobileStep, MobileSteps } from "./MobileSteps";
import { Bifold } from "./Bifold";

export const MultiStepForm = {
    Container,
    Step,
    Steps,
    Header,
    Video,
    TextBlock,
    MobileSteps,
    MobileStep,
    Bifold,
};
